import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ImageNavControlsProps {
    boxCount: number;
    onPrev: () => void;
    onNext: () => void;
}

/**
 * ImageNavControls — bottom-center floating pill per UI mockup § "Bottom-
 * center: image nav". Prev / box count / Next.
 */
export default function ImageNavControls({ boxCount, onPrev, onNext }: ImageNavControlsProps) {
    const { t } = useTranslation('canvas');
    return (
        <div className="absolute bottom-4 left-1/2 -trangray-x-1/2 z-20 flex items-center gap-2 rounded-full bg-white/95 dark:bg-gray-900/95 backdrop-blur-sm border border-gray-200 dark:border-gray-800 shadow-lg px-2 py-1">
            <button
                type="button"
                onClick={onPrev}
                className="rounded-full p-1.5 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors duration-150"
                aria-label={t('prev_image')}
                title={t('prev_image')}
            >
                <ChevronLeft className="h-4 w-4" />
            </button>
            <span className="text-xs text-gray-500 dark:text-gray-400 px-2">
                {t('boxes_label', { count: boxCount })}
            </span>
            <button
                type="button"
                onClick={onNext}
                className="rounded-full p-1.5 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors duration-150"
                aria-label={t('next_image')}
                title={t('next_image')}
            >
                <ChevronRight className="h-4 w-4" />
            </button>
        </div>
    );
}
